'use client';

import dynamic from 'next/dynamic';

const MatrixBackground = dynamic(() => import('@/components/ui/MatrixBackground'), { ssr: false });
const CookieBanner = dynamic(() => import('@/components/ui/CookieBanner'), { ssr: false });
const MobileHistorySwipe = dynamic(() => import('@/components/ui/MobileHistorySwipe'), {
  ssr: false,
});

export default function ClientComponentsWrapper() {
  return (
    <>
      <MatrixBackground />
      <MobileHistorySwipe />
      <CookieBanner />
    </>
  );
}
